import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, DeleteData, PaginationParams, Wrapper } from '../../type';
import {
  ChangeSubscriptionPlanRequest,
  GetFeaturesListResponse,
  GetSubscriptionPlanByBusiness,
  GetSubscriptionPlanByIdResponse,
  GetSubscriptionPlanHistory,
  GetSubscriptionPlanResponse,
  GetSubscriptionStatusesByBusiness,
  SubscriptionPlan,
  SubscriptionPlanResponse,
} from './interface';

export class SubscriptionPlanProfile extends BaseService {
  async createSubscriptionPlan(req: SubscriptionPlan) {
    return this.post<SubscriptionPlanResponse, SubscriptionPlan>(`${this.apiUrl}/api/subscription/plans`, req);
  }

  async getSubscriptionPlans(params: PaginationParams) {
    return this.get<GetSubscriptionPlanResponse>(`${this.apiUrl}/api/subscription/plans`, params);
  }

  async getSubscriptionPlansDropdown(params: PaginationParams) {
    return this.get<GetSubscriptionPlanResponse>(`${this.apiUrl}/api/subscription/plans/get`, params);
  }

  async updateSubscriptionPlan(id: number, req: SubscriptionPlan) {
    return this.put<SubscriptionPlan, SubscriptionPlan>(`${this.apiUrl}/api/subscription/plans/${id}`, req);
  }

  async deleteSubscriptionPlan(id: number) {
    return this.delete<DeleteData>(`${this.apiUrl}/api/subscription/plans/${id}`);
  }

  async getSubscriptionPlanById(id: number | undefined) {
    return this.get<GetSubscriptionPlanByIdResponse>(`${this.apiUrl}/api/subscription/plans/${id}`);
  }

  async changeStatusSubscriptionPlan(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<Wrapper, ChangeStatusRequest>(`${this.apiUrl}/api/subscription/plans/${active}/${id}`, req);
  }

  async getFeaturesList(params: PaginationParams) {
    return this.get<GetFeaturesListResponse>(`${this.apiUrl}/api/feature`, params);
  }

  async getSubscriptionPlanByBusiness(id: string | number | undefined) {
    return this.get<GetSubscriptionPlanByBusiness>(`${this.apiUrl}/api/business-plan/business/${id}`);
  }

  async getSubscriptionPlansHistory(params: PaginationParams) {
    return this.get<GetSubscriptionPlanHistory>(`${this.apiUrl}/api/business-plan-histories`, params);
  }

  async changeSubscriptionPlan(req: ChangeSubscriptionPlanRequest) {
    return this.patch<Wrapper, ChangeSubscriptionPlanRequest>(
      `${this.apiUrl}/api/businesses/${req?.businessId}/plan/${req?.planId}`,
      req
    );
  }

  async suspendSubscriptionPlan(req: ChangeSubscriptionPlanRequest) {
    return this.patch<Wrapper, ChangeSubscriptionPlanRequest>(
      `${this.apiUrl}/api/business-plan/${req?.planId}/status/${req?.status}`,
      req
    );
  }

  async updateAutoRenew(businessId: number, autoRenew: boolean) {
    return this.patch<Wrapper, Record<string, never>>(
      `${this.apiUrl}/api/business-plan/${businessId}/autorenew/${autoRenew}`,
      {}
    );
  }

  async getSubscriptionStatusesByBusiness(id: number | null | undefined) {
    return this.get<GetSubscriptionStatusesByBusiness>(`${this.apiUrl}/api/businesses/getplan/${id}`);
  }
}
